<template>
  <div id="app">
    <global-header :display="display" :enterpriseName="enterpriseName" :userName="userName" @logout="logout" />
    <sub-header v-show="display" :userDiv="userDiv" />
    <screen-title v-show="display" :screenTitle="screenTitle" />
    <message-parts :message="message" :errorFlag="errorFlag" />
    <router-view @login="login" @setScreenTitle="setScreenTitle" @notDisplayHeader="notDisplayHeader" @setMessage="setMessage" />
    <global-footer />
  </div>
</template>

<script>
import GlobalHeader from '@/components/partials/GlobalHeader'
import GlobalFooter from '@/components/partials/GlobalFooter'
import SubHeader from '@/components/partials/SubHeader'
import ScreenTitle from '@/components/partials/ScreenTitle'
import MessageParts from '@/components/partials/Message'
import 'whatwg-fetch'

if (window.fetch === undefined) {
  window.fetch = fetch
}

export default {
  name: 'App',
  data () {
    return {
      display: {
        type: Boolean,
        default: false
      },
      userDiv: {
        type: Number,
        default: ''
      },
      screenTitle: null,
      message: null,
      errorFlag: false,
      enterpriseName: null,
      userName: null
    }
  },

  errorCaptured (err, vm, info) {
    console.log(err)
    this.errorFlag = true
    if (err.response) {
      switch (+err.response.status) {
        case 401:
          this.$router.push({name: 'login', params: { propMessage: '有効期限が切れました。再度ログインを行ってください。' }})
          break
        case 404:
          this.message = '出力対象がありませんでした。'
          break
        default:
          this.message = '処理に失敗しました。'
      }
    } else {
      this.message = err.message
    }
  },

  mounted () {
    this.userDiv = this.$session.get('userDiv')
    if (this.$session.get('accessToken')) {
      this.display = true
    } else {
      this.display = false
    }
  },

  methods: {
    /**
     * スクリーンタイトルの設定
     */
    setScreenTitle (screenTitle) {
      this.screenTitle = screenTitle
      this.enterpriseName = this.$session.get('enterpriseName')
      this.userName = this.$session.get('userName')
    },

    /**
     * メッセージに表示するテキストの設定
     */
    setMessage (message, errorFlag) {
      this.errorFlag = errorFlag
      this.message = message
    },

    /**
     * ヘッダ箇所の非表示処理
     */
    notDisplayHeader () {
      this.display = false
    },

    /**
     * ログアウト処理
     */
    async logout () {
      this.message = null
      await this.axios.post('/api/logout', {}, {
        headers: {
          'Authorization': this.$session.get('accessToken')
        }
      })
      this.$session.destroy()
      this.userDiv = null
      this.display = false
      this.screenTitle = null
      this.message = null
      this.errorFlag = false
      this.enterpriseName = null
      this.userName = null
      this.$router.push('/')
    },

    /**
     * ログイン処理
     */
    login (display, userDiv, enterpriseName, userName) {
      this.display = display
      this.userDiv = userDiv
      this.enterpriseName = enterpriseName
      this.userName = userName

      // 権限によってログイン後の遷移画面を分ける
      switch (userDiv) {
        case 0:
          this.$router.push('/enterpriseList')
          break
        case 1:
          this.$router.push('/inventoryInfoList')
          break
        case 2:
          this.$router.push('/inventoryInfoList')
          break
        default:
          this.$session.destroy()
          this.$router.push('/')
          break
      }
    }
  },
  components: {
    GlobalHeader,
    GlobalFooter,
    SubHeader,
    ScreenTitle,
    MessageParts
  }
}
</script>

<style>
@import './../static/css/style.css';
@import './../static/font-awesome/css/all.min.css';
</style>



// WEBPACK FOOTER //
// src/App.vue